var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.00363636 2.22182H5.22727L4.10909 3.34L2.44273 5.00636L0 7.44909L0.523636 7.97273L2.96636 5.53045L4.63273 3.86364L5.74364 2.75273V7.96909H7.96546V0H0.00363636V2.22182Z","fill":"white"}));
}

Arrow.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
